<template>
    <div class="product1">
       <!--banner-->
      <div class="bannerBox">
        <div class="banner">
          <div class="mainContainer">
            <p class="titleBig gw_fadeInUp gw_animateDelay_01">漏洞扫描</p>
            <p class="gw_fadeInUp gw_animateDelay_02">“先黑客一步发现问题，并快速解决”——牛盾借助自主构建的漏洞扫描系统，全面检测用户的域名、web和主机漏洞，并提供精准的检测报告和分析建议，保证IT业务系统高效稳定的运行。</p>
            <!--<button class="btns" @click="startNow">立即开始</button>-->
          </div>
        </div>
      </div>
      <!--功能优势-->
      <div class="mainContainer functionAdv" id="gw_animateBox1">
        <p class="title">功能优势</p>
        <ul class="clearFloat">
          <li>
            <div class="icons icons1">
            </div>
            <p>检测全面</p>
            <div class="iconTxt gw_fadeInUp gw_animateDelay_03">包括但不限于：Web应用、主机、弱密码；对企业与个人的多种资产进行专业的漏洞扫描。</div>
          </li>
          <li>
            <div class="icons icons2">
            </div>
            <p>智能扫描</p>
            <div class="iconTxt gw_fadeInUp gw_animateDelay_03">扫描引擎智能调度，保证用户业务不中断；智能无害扫描，避免扫描脏数据写入用户数据库。</div>
          </li>
          <li>
            <div class="icons icons3">
            </div>
            <p>内容检测</p>
            <div class="iconTxt gw_fadeInUp gw_animateDelay_03">基于深度学习技术和大量的样本库，帮助客户快速准确的检测网页是否存在违规内容。</div>
          </li>
          <li>
            <div class="icons icons4">
            </div>
            <p>优质报告</p>
            <div class="iconTxt" :class="{gw_fadeInUp:isUp1,gw_isShow:isShow1}">报告可在线查看，报告内容丰富，图表多样，多个维度展示安全风险，满足不同场景下的多样化需求。</div>
          </li>
          <li>
            <div class="icons icons5">
            </div>
            <p>专家解读</p>
            <div class="iconTxt" :class="{gw_fadeInUp:isUp1,gw_isShow:isShow1}">用户直接对接专业技术人员，解答漏洞的形成原因和危害等技术问题，并解决问题。</div>
          </li>
          <li>
            <div class="icons icons6">
            </div>
            <p>免费检测</p>
            <div class="iconTxt" :class="{gw_fadeInUp:isUp1,gw_isShow:isShow1}">提供免费的漏洞扫描深度检测，不同于其他免费扫描，更全面更深入，响应国家号召，促进网络安全建设。</div>
          </li>
        </ul>
      </div>
      <!--应用场景-->
      <div class="applicationSce" id="gw_animateBox2">
        <div class="mainContainer">
          <p class="title">应用场景</p>
          <div class="flex_space">
             <div class="box box1">
               <div class="img">
                 <div class="flex_align"><span>业务上线</span></div>
               </div>
               <p :class="{gw_fadeInUp:isUp2,gw_isShow:isShow2}">业务上线之前可以通过安全检测服务对新业务做一次完整扫描，防患于未然，及时处理，防止漏洞被利用。</p>
             </div>
             <div class="box box2">
               <div class="img">
                 <div class="flex_align"><span>安全检查</span></div>
               </div>
               <p :class="{gw_fadeInUp:isUp2,gw_isShow:isShow2}">互联网的金融用户，需要做一些等保检查；周期性的业务例行安全检测，全面整体评估安全性。</p>
             </div>
             <div class="box box3">
               <div class="img">
                 <div class="flex_align"><span>监管机构</span></div>
               </div>
               <p :class="{gw_fadeInUp:isUp2,gw_isShow:isShow2}">一键式启动扫描，可以更好的提高检查工作的效率，帮助权威监管部门和检查机构树立形象。</p>
             </div>
             <div class="box box4">
               <div class="img">
                 <div class="flex_align"><span>政府、教育</span></div>
               </div>
               <p :class="{gw_fadeInUp:isUp2,gw_isShow:isShow2}">政府、教育应用系统内容漏洞修复不及时等问题严重影响了单位形象。Web 漏洞扫描避免漏洞被利用影响系统安全。</p>
             </div>
          </div>
        </div>
      </div>
      <!--先黑客一步发现问题-->
      <div class="methods" id="gw_animateBox3">
        <div  class="mainContainer flex_space">
          <div class="box_left">
            <div :class="{gw_fadeInUp:isUp3,gw_isShow:isShow3}">
              <h3>先黑客一步发现问题</h3>
              <p>更高效的漏扫服务，更全面的安全监测，更专业的专家分析</p>
            </div>
            <div class="steps" :class="{gw_fadeInUp:isUp3,gw_isShow:isShow3,gw_animateDelay_01:isUp3}">
              <i></i><span>立即注册,添加域名</span>
            </div>
            <div class="steps steps2" :class="{gw_fadeInUp:isUp3,gw_isShow:isShow3,gw_animateDelay_02:isUp3}">
              <i></i><span>快速验证，免费扫描</span>
            </div>
            <div class="steps steps3" :class="{gw_fadeInUp:isUp3,gw_isShow:isShow3,gw_animateDelay_03:isUp3}">
              <i></i><span>查看报告，修复漏洞</span>
            </div>
          </div>
          <div class="box_right">
            <div></div>
          </div>
        </div>
      </div>
      <div class="gw_homefooter">
        <div class="gw_footerAdv">
          <canvas id="canvas1" style="width:100%;height:100%;"></canvas>
          <div class="gw_footerAdvtitle">
            <p>无需等待，赶快来看看你的网站安全吧</p>
            <!--<div><button class="btns" @click="startNow">立即开始</button></div>-->
          </div>
        </div>
        <div class="gw_homefooterBox">
          <footBar></footBar>
        </div>
      </div>
      <!--返回顶部-->
      <returnTop></returnTop>
    </div>
</template>

<script>
   import footBar from '../../components/footerbar'
   import returnTop from '../../components/returnTop'
   import {getCanvas,startAtonce} from "../../api/common";

   export default {
      name: "product1",
      data(){
        return{
          isUp1:false,
          isShow1:true,
          isUp2:false,
          isShow2:true,
          isUp3:false,
          isShow3:true
        }
      },
      components:{
        footBar,returnTop
      },
      mounted(){
        getCanvas('canvas1');
        window.addEventListener('scroll',this.scrollFun1);
      },
     destroyed(){
       window.removeEventListener('scroll',this.scrollFun1);
     },
      methods:{
        startNow(){
          startAtonce(()=>{
            this.$bus.$emit('login');
          },()=>{
            this.$router.push('/mySite');
            window.scrollTo({
              top:0
            })
          });
        },
        scrollFun1(){
          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
          let gw_animateBox1 = document.getElementById('gw_animateBox1');
          let gw_animateBox2 = document.getElementById('gw_animateBox2');
          let gw_animateBox3 = document.getElementById('gw_animateBox3');
          // console.log('scrollTop=',gw_animateBox3.offsetTop-scrollTop);
          let top_value1 = gw_animateBox1.offsetTop-scrollTop;
          let top_value2 = gw_animateBox2.offsetTop-scrollTop;
          let top_value3 = gw_animateBox3.offsetTop-scrollTop;
          // let top_value = gw_animateBox1.getBoundingClientRect().top;//有兼容性问题
          if(top_value1<=420){
            this.isUp1 = true;
            this.isShow1 = false;
          }
          if(top_value2<=560){
            this.isUp2 = true;
            this.isShow2 = false;
          }
          if(top_value3<=520){
            this.isUp3 = true;
            this.isShow3 = false;
          }
        }
      }
    }
</script>

<style scoped lang="scss">
  @mixin transtion_me($option,$second,$timing){
    transition: $option $second $timing;
    -moz-transition: $option $second $timing; /* Firefox 4 */
    -webkit-transition: $option $second $timing; /* Safari 和 Chrome */
    -o-transition: $option $second $timing; /* Opera */
  }
  @mixin  transform_me($option){
    transform: $option;
    -ms-transform:$option; 	/* IE 9 */
    -moz-transform:$option; 	/* Firefox */
    -webkit-transform:$option; /* Safari 和 Chrome */
    -o-transform:$option;
  }

  @mixin transitionAll03 {
    -o-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
  }

    .product1{
      .title{
        font-family: 'pingfangBold';
        font-size: 24px;
        color: #272727;
        margin:0 0 20px;
      }
      .bannerBox {
        .banner {
          background: url("../../assets/img/product1/banner.jpg") no-repeat center;
          background-size: cover;
        }
      }
    }
   .functionAdv{
     padding-bottom:37px;
     ul{
       li{
         float: left;
         width:380px;
         height:190px;
         border: 1px solid #D8D8D8;
         box-sizing: border-box;
         margin-bottom:35px;
         padding:30px;
         position: relative;
         text-align: left;
         overflow: hidden;
         margin-right:30px;
         &:nth-child(3){
           margin-right:0;
         }
         &:nth-child(6){
           margin-right:0;
         }
         .icons{
            position:absolute;
           width:100px;
           height:95px;
           right:-13px;
           top:-18px;
         }
         .icons1{
           background:url("../../assets/product.svg") no-repeat -983px -186px;
         }
         .icons2{
           width:85px;
           height:80px;
           right:-6px;
           top:-14px;
           background:url("../../assets/product.svg") no-repeat -991px -441px;
         }
         .icons3{
           width:78px;
           height:84px;
           right:-2px;
           top:-6px;
           background:url("../../assets/product.svg") no-repeat -994px -318px;
         }
         .icons4{
           width:78px;
           height:91px;
           right:-8px;
           top:-18px;
           background:url("../../assets/product.svg") no-repeat -994px -692px;
         }
         .icons5{
           width:80px;
           height:82px;
           right:-8px;
           top:-18px;
           background:url("../../assets/product.svg") no-repeat -993px -820px;
         }
         .icons6{
           width:96px;
           height:96px;
           right:-23px;
           top:-21px;
           background:url("../../assets/product.svg") no-repeat -985px -558px;
         }
         p{
           font-size: 20px;
           color: #000000;
           margin-bottom:37px;
         }
         .iconTxt{
           text-align: left;
           font-size:14px;
           color: #4A4A4A;
         }
       }
     }
   }
   .applicationSce{
     height:459px;
     background: #F5F5F5;
     .mainContainer{
       padding-bottom:70px;
       .box{
         width:280px;
         p{
           font-size: 14px;
           color: #4A4A4A;
           margin-top:10px;
            text-align: left;
         }
         .img{
           width:280px;
           height:180px;
           background:url("../../assets/img/product1/img1.png") no-repeat center;
           position: relative;
           div{
             position:absolute;
             bottom:0;
             left:0;
             width:100%;
             height:35px;
             background: rgba(0,0,0,0.50);
             padding-left:10px;
             box-sizing: border-box;
             span{
               font-size: 14px;
               color: #FFFFFF;
               font-family: 'pingfangBold';
               @include transform_me(translate3d(0,0,0))
             }
           }
           @include transtion_me(all,0.3s,linear);
           &:hover{
             @include transform_me(scale(1.05));
           }
         }
       }
       .box2{
          .img{
            background:url("../../assets/img/product1/img2.png") no-repeat center;
          }
       }
       .box3{
         .img{
           background:url("../../assets/img/product1/img3.png") no-repeat center;
         }
       }
       .box4{
         .img{
           background:url("../../assets/img/product1/img4.png") no-repeat center;
         }
       }
     }
   }
   .methods{
     height:549px;
     background:#fff;
     .mainContainer{
       padding: 80px 0 55px 20px;
       .box_left{
         text-align: left;
         h3{
           font-size: 30px;
           color: #000000;
           font-family: 'pingfangBold';
           margin-bottom:5px;
         }
         p{
           font-size: 14px;
           color: #4A4A4A;
           margin-bottom: 53px;
         }
         .steps{
           margin-bottom:30px;
           i{
             display:inline-block;
             width:59px;
             height:50px;
             background:url("../../assets/img/product1/num1.png") no-repeat center;
             background-size:100% 100%;
             vertical-align: middle;
             margin-right:17px;
           }
           span{
             display:inline-block;
             width:225px;
             height:57px;
             line-height: 50px;
             text-align: center;
             font-size: 18px;
             color: #FFFFFF;
             background:url("../../assets/img/product1/steps.png") no-repeat center;
             background-size:100% 100%;
           }
         }
         .steps2{
           i{
             background:url("../../assets/img/product1/num2.png") no-repeat center;
             background-size:100% 100%;
           }
         }
         .steps3{
           i{
             background:url("../../assets/img/product1/num3.png") no-repeat center;
             background-size:100% 100%;
           }
         }
       }
       .box_right{
         div{
           width:632px;
           height:419px;
           background:url("../../assets/img/product1/box_right.png") no-repeat center;
           background-size:100% 100%;
         }
       }
     }
   }
   .gw_homefooter{
     .gw_footerAdv{
        height:210px;
       position:relative;
       background:#3FA4F8;
       .gw_footerAdvtitle{
         width:1200px;
         height:210px;
         position: absolute;
         top:0;
         left:50%;
         margin-left:-600px;
         p{
           font-size: 36px;
           color: #FFFFFF;
           font-family: 'pingfangBold';
           margin:55px 0 25px;
         }
         .btns{
           width:150px;
           height:50px;
           font-size: 18px;
           background: rgba(255,255,255,0.30);
           border: 1px solid #FFFFFF;
           border-radius: 2px;
           cursor: pointer;
         }
       }
     }
     .gw_homefooterBox{
       height:160px;
     }
   }
</style>



// WEBPACK FOOTER //
// src/views/product/product1.vue